export const GET_USER = "GET_USER";
export const SET_USER = "SET_USER";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
